import types from './types'
import apiAccount from 'api/account'
import dkvConfiguration from 'constants/dkv.constants'
import { setUserData } from 'redux/actions/user'

/**
 * Add new auth token
 * @param {string} nxAuthToken
 * @param {string} tokenRefresh
 */
const add = (nxAuthToken, tokenRefresh = '') => ({
  type: types.add,
  nxAuthToken,
  tokenRefresh
})

const tokenRefresh = () => async (dispatch, oldState) => {
  if (!dkvConfiguration.isDKV) return { result: false }

  try {
    const { tokenRefresh } = oldState().nxAuthToken
    const { data } = await apiAccount.tokenRefresh(tokenRefresh)

    if (data.success) {
      dispatch(add(data.token, data.tokenRefresh))
      dispatch(setUserData({ authToken: data.token }))
    }

    return { result: data.success, token: data.token }
  } catch (error) {
    return { result: false }
  }
}

/**
 * Remove auth token
 */
const remove = () => ({ type: types.remove })

export default {
  add,
  remove,
  tokenRefresh
}
